<template>
  <GlobalWindow :title="title" :visible.sync="visible" :confirm-working="isWorking" @confirm="handleConfirm">
    <el-form :model="form" ref="form" :rules="rules">
      <el-form-item label="场景" prop="scene"><el-select v-model="form.scene" placeholder="场景">
        <el-option label="日记模板" value="diary_write" />
        <el-option label="觉察模板" value="insight_detail" />
      </el-select></el-form-item>
      <el-form-item label="模板配置ID" prop="templateConfigId"><el-input v-model="form.templateConfigId" placeholder="模板配置ID" /></el-form-item>
      <el-form-item label="主标题" prop="heroTitle"><el-input v-model="form.heroTitle" placeholder="主标题" /></el-form-item>
      <el-form-item label="副标题" prop="heroSubtitle"><el-input type="textarea" :rows="4" v-model="form.heroSubtitle" placeholder="副标题（支持多行）" /></el-form-item>
      <el-form-item label="保存按钮文案" prop="saveButtonText"><el-input v-model="form.saveButtonText" placeholder="保存按钮文案" /></el-form-item>
      <el-form-item label="生成按钮文案" prop="generateButtonText"><el-input v-model="form.generateButtonText" placeholder="生成按钮文案" /></el-form-item>
      <el-form-item label="三个维度配置">
        <el-row :gutter="10" v-for="(item, index) in insightItems" :key="index" style="margin-bottom: 10px;">
          <el-col :span="6"><el-input v-model="item.theme" placeholder="维度名" /></el-col>
          <el-col :span="6"><el-input type="textarea" v-model="item.title" placeholder="标题" /></el-col>
          <el-col :span="4"><el-input v-model="item.icon" placeholder="图标" /></el-col>
          <el-col :span="7"><el-input type="textarea" v-model="item.description" placeholder="描述" /></el-col>
          <el-col :span="1"><el-button type="danger" icon="el-icon-delete" circle size="mini" @click="removeInsightItem(index)" /></el-col>
        </el-row>
        <el-button type="primary" size="mini" icon="el-icon-plus" @click="addInsightItem">添加维度</el-button>
      </el-form-item>
    </el-form>
  </GlobalWindow>
</template>
<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalWindow from '@/components/common/GlobalWindow'
export default {
  name: 'operainsightTemplateWindow', extends: BaseOpera, components: { GlobalWindow },
  data() {
    return {
      insightItems: [
        { theme: '认知发现', title: '我为何这般思考', icon: '✿', description: '' },
        { theme: '情绪探索', title: '我为何这般心绪', icon: '✦', description: '' },
        { theme: '行为洞察', title: '我为何这般行事', icon: '✦', description: '' }
      ],
      form: { id: null, scene: 'insight_detail', templateConfigId: '', heroTitle: '', heroSubtitle: '', saveButtonText: '', generateButtonText: '', insightItems: '' },
      rules: {}
    }
  },
  methods: {
    addInsightItem() {
      this.insightItems.push({ theme: '', title: '', icon: '', description: '' })
    },
    removeInsightItem(index) {
      this.insightItems.splice(index, 1)
    },
    handleConfirm() {
      this.form.insightItems = JSON.stringify(this.insightItems)
      this.confirm()
    },
    open(title, row) {
      if (row) {
        this.form = { ...row }
        if (row.insightItems) {
          try {
            this.insightItems = typeof row.insightItems === 'string' ? JSON.parse(row.insightItems) : row.insightItems
          } catch (e) {
            this.insightItems = []
          }
        }
      } else {
        this.form = { id: null, scene: 'insight_detail', templateConfigId: '', heroTitle: '', heroSubtitle: '', saveButtonText: '', generateButtonText: '', insightItems: '' }
        this.insightItems = [
          { theme: '认知发现', title: '我为何这般思考', icon: '✿', description: '' },
          { theme: '情绪探索', title: '我为何这般心绪', icon: '✦', description: '' },
          { theme: '行为洞察', title: '我为何这般行事', icon: '✦', description: '' }
        ]
      }
      this.title = title
      this.visible = true
    }
  },
  created() { this.config({ api: '/rentHouse/insightTemplate', 'field.id': 'id' }) }
}
</script>